import {useCallback,useEffect,useState} from 'react';
import {api} from '../services/api';

// Catálogo de dojangs (más la opción "Otro", que permite capturar uno nuevo).
// `reload` vuelve a consultarlo, p. ej. después de guardar un dojang nuevo.
const OTHER={id: 'otro',label: 'Otro'};

export function useDojangs() {
  const [dojangs,setDojangs]=useState([]);

  const reload=useCallback(()=>{
    api('/dojangs').then(data=> setDojangs(data.dojangs)).catch(()=> setDojangs([]));
  },[]);

  useEffect(reload,[reload]);

  return {dojangs: [...dojangs,OTHER],reload};
}
